// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._165zM{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:8px;gap:8px;grid-gap:.5rem;gap:.5rem}@media(min-width:768px){._165zM{-ms-flex-pack:center;justify-content:center}}.mpepY{border:1px solid #9fa0a0;border-radius:.25rem;color:#9fa0a0;background-color:#fff;padding:.375rem .75rem;cursor:pointer}._1oSy8{border:1px solid #0373f9;color:#0373f9}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_165zM",
	"item": "mpepY",
	"selected": "_1oSy8"
};
module.exports = exports;
